// Backend returns 403 "Old reminder system is disabled for this practice." from
// GET /practices/{id}/reminders/ when a practice has tasks-v1 off. Background
// (non user-initiated) read fetches must treat this as "no reminders" - no error
// toast and no never-settling loader.
export const EMPTY_REMINDERS = Object.freeze({ count: 0, results: [] });

export function isOldRemindersDisabled(response) {
    if (response?.status !== 403) return false;
    let body = response?.data;
    if (body && typeof body !== 'string') {
        try { body = JSON.stringify(body); } catch (e) { body = ''; }
    }
    return /reminder system is disabled/i.test(body || '');
}
